import { AppProviders } from "@components/App/AppProviders";
import { ProtectedRoute } from "@components/Auth/ProtectedRoute";
import { EnvBanner } from "@components/EnvBanner";
import { Layout } from "@components/Layout";
import { LytefloLoadingScreen } from "@components/LytefloLoadingScreen";
import { NotFound } from "@components/NotFound";
import { routes } from "@constants/routes";
import { PortalRoutes } from "@lyteflo/types";
import { RouteConfig } from "@portalTypes/routes";
import { Suspense } from "preact/compat";
import { Route, Router, Switch } from "wouter";

const RouteWrapper = ({
  component: Component,
  isProtected,
  layout: RouteLayout,
  feature,
  params = {},
  fullPage = false,
}: RouteConfig) => {
  const content = Component ? <Component params={params} /> : null;
  const wrappedContent = RouteLayout ? (
    <RouteLayout>{content}</RouteLayout>
  ) : (
    content
  );

  return isProtected ? (
    <ProtectedRoute feature={feature}>
      {fullPage ? wrappedContent : <Layout>{wrappedContent}</Layout>}
    </ProtectedRoute>
  ) : (
    wrappedContent
  );
};

export const AppRouter = () => {
  return (
    <AppProviders>
      <EnvBanner />
      <Router>
        <Suspense fallback={<LytefloLoadingScreen />}>
          <Switch>
            {routes.map((route) => (
              <Route key={route.path} path={route.path}>
                {(params: Record<string, string>) => (
                  <RouteWrapper {...route} params={params} />
                )}
              </Route>
            ))}
            <Route path={PortalRoutes.PUBLIC_NOT_FOUND}>
              {() => <NotFound redirectToPortal={false} />}
            </Route>
            <Route path="*">{() => <NotFound redirectToPortal />}</Route>
          </Switch>
        </Suspense>
      </Router>
    </AppProviders>
  );
};
